export const ROUTE_PREFIX = '';

export const addRoutePrefix = (path: string): string => {
	return `${path}`;
};